export default __webpack_public_path__ + "static/media/ic_search.50dfdc81.svg";